import { render, staticRenderFns } from "./withHoldingConfirm.vue?vue&type=template&id=23f1d77b&scoped=true&"
import script from "./withHoldingConfirm.vue?vue&type=script&lang=js&"
export * from "./withHoldingConfirm.vue?vue&type=script&lang=js&"
import style0 from "./withHoldingConfirm.vue?vue&type=style&index=0&id=23f1d77b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1d77b",
  null
  
)

export default component.exports